import React from "react";

interface DashboardCardProps {
  title?: string;
  children: React.ReactNode;
  emptyText?: string;
  isEmpty?: boolean;
  className?: string;
}

function cn(...classes: Array<string | undefined>) {
  return classes.filter(Boolean).join(" ");
}

export const DashboardCard: React.FC<DashboardCardProps> = ({ title, children, emptyText, isEmpty, className }) => {
  return (
    <div className={cn("space-y-2", className)}>
      {title && <h3 className="text-sm font-semibold text-slate-800 dark:text-slate-100">{title}</h3>}
      {isEmpty && emptyText ? (
        <p className="text-sm text-slate-600 dark:text-slate-300">{emptyText}</p>
      ) : (
        children
      )}
    </div>
  );
};
